// Definition of Regex Constants

export default {
  isEmail: /^[_A-Za-z0-9]+(.[_A-Za-z0-9]+)*@[A-Za-z0-9-]+(.[A-Za-z0-9-]+)*(.[A-Za-z]{2,4})$/,
  isNumber: /^[\u06F0-\u06F9\u0660-\u06690-9]*$/,
  notNumber: /^([^\u06F0-\u06F9\u0660-\u06690-9]*)$/,
  isNationalCode: /^[\u06F0-\u06F9\u0660-\u06690-9]{10}$/,
  isTel: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
  isPersian: /^[\u0621-\u063A\u0641-\u064A\u0676-\u06D1\s\u06F0-\u06F9\u0660-\u06690-9./]*$/,
  notEnglish: /^[^/._@#$%*+=A-Za-z0-9]*$/,
  isDecimal: /^\d+\.\d{0,20}$/,
  isRole: /^[_A-Z]*$/,
  isPermission: /^[/.A-Za-z0-9]*$/,
  isAlias: /^[-_a-z0-9]*$/,
  setAlias: /([^-_a-z0-9])+/g,
};
